import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Stack, Type } from 'react-spark';
import { FONT_SIZES } from '../../../../utils/novaTypography';

export class OffersV3TermSelector extends Component {
    static propTypes = {
        hasMultipleTerms: PropTypes.bool.isRequired,
        offersForAmount: PropTypes.array.isRequired,
        selectedTerm: PropTypes.number,
        onTermSelect: PropTypes.func.isRequired,
    };

    static defaultProps = {
        selectedTerm: null,
    };

    render() {
        const { hasMultipleTerms, offersForAmount, selectedTerm, onTermSelect } = this.props;

        if (!hasMultipleTerms) {
            return null;
        }

        // Get available terms from offers data (sort by duration)
        const availableTerms = offersForAmount
            .map(offer => offer.duration)
            .sort((a, b) => a - b);

        return (
            <Stack>
                <Stack.Item className="sprk-u-PaddingBottom--a">
                    <Type.DisplayFive className='sprk-u-mvn sprk-u-FontWeight--bold' style={{ fontSize: FONT_SIZES.body }}>
                        Select repayment term (months)
                    </Type.DisplayFive>
                </Stack.Item>
                <Stack.Item>
                    <div 
                        className='term-selector-container'
                        role="radiogroup"
                        aria-label="Select repayment term"
                    >
                        {availableTerms.map((term) => (
                            <button
                                key={term}
                                id={`offers_term_${term}`}
                                className={`term-selector-button ${selectedTerm === term ? 'selected-term' : ''}`}
                                onClick={() => onTermSelect(term)}
                                type='button'
                                role="radio"
                                aria-checked={selectedTerm === term}
                                aria-label={`${term} months repayment term`}
                            >
                                {term}
                            </button>
                        ))}
                    </div>
                </Stack.Item>
            </Stack>
        );
    }
}
